import { computed, effect, signal } from "@preact/signals";
import { getPdfThumbnails } from "../api/utils";
import { ShareAction, SharedFile } from "./interfaces";

let fileIdx = 0;

const makeShare = () => {
    const loading = signal(false);
    const error = signal<string | null>(null);
    const sharedFiles = signal<SharedFile[]>([]);
    const clicked = signal(false);
    const action = signal<ShareAction | null>(null);
    const isHeaderHidden = computed(
        () => clicked.value && action.value === ShareAction.UpdateExpense,
    );

    effect(() => {
        const hidden = isHeaderHidden.value;

        document.documentElement.classList.toggle("share", hidden);
    });

    const processSharedFiles = async (
        files: SharedMobile.InputSharedFile[],
    ) => {
        loading.value = true;

        try {
            sharedFiles.value = await Promise.all(
                files.map(async (file) => {
                    const array = Uint8Array.from(
                        atob(file.base64.split(",")[1]),
                        (c) => c.charCodeAt(0),
                    );

                    return {
                        ...file,
                        id: String(++fileIdx),
                        blob: new Blob([array], {
                            type: file.type,
                        }),
                        thumbnails:
                            file.type === "application/pdf"
                                ? await getPdfThumbnails(array.buffer)
                                : [file.base64],
                    };
                }),
            );
        } catch (err: unknown) {
            const message =
                err instanceof Error ? err.message : "Unknown error";

            error.value = message;
        }

        loading.value = false;
    };

    const click = (selectedAction: ShareAction) => {
        clicked.value = true;
        action.value = selectedAction;
    };

    const cleanup = () => {
        sharedFiles.value = [];
        action.value = null;
        clicked.value = false;
        loading.value = false;
        error.value = null;
        delete window.SharedMobile?.sharedFiles;
    };

    const check = () => {
        window.SharedMobile?.shareFiles?.();
    };

    window.SharedMobile ??= {};

    window.SharedMobile.shareFiles = () => {
        if (window.SharedMobile?.sharedFiles) {
            processSharedFiles(window.SharedMobile.sharedFiles);
        }
    };

    return {
        loading,
        error,
        sharedFiles,
        clicked,
        action,
        isHeaderHidden,
        click,
        cleanup,
        check,
    };
};

export default makeShare;
